import { Link } from "react-router";
import { ArrowLeft } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { IntegrationCard } from "./_components/integration-card";
import { useIntegrationsStatus } from "./use-integrations-status";

// Phase 7 sub-bucket 18 — SPA port of /app/admin/settings/integrations/page.tsx.
// Status pills for HubSpot + Slack come from /api/settings/integrations/status
// (env-driven on the worker — the SPA has no direct env access).

export function IntegrationsListPage() {
  const statusQuery = useIntegrationsStatus();

  return (
    <div>
      <Link
        to="/admin/settings"
        className="mb-4 inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="h-3 w-3" />
        Back to settings
      </Link>

      <header className="mb-7">
        <h1 className="font-display text-3xl font-semibold tracking-tight">
          Integrations
        </h1>
        <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
          Connect Colab to your CRM, messaging, and partnership intelligence
          tools.
        </p>
      </header>

      {statusQuery.isLoading ? (
        <div className="grid gap-3 lg:grid-cols-2">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="h-24 w-full rounded-lg" />
          ))}
        </div>
      ) : (
        <div className="grid gap-3 lg:grid-cols-2">
          <IntegrationCard
            name="HubSpot"
            description="Sync partners, deals, and accounts from your HubSpot portal. Source of truth for the Deals kanban."
            status={statusQuery.data?.hubspot.status ?? "not_configured"}
            configureHref="/admin/settings/integrations/hubspot"
            provider="hubspot"
          />
          <IntegrationCard
            name="Slack"
            description="Post deal-registration and form-submission notifications to a Slack channel."
            status={statusQuery.data?.slack.status ?? "not_configured"}
            provider="slack"
          />
          <IntegrationCard
            name="Email delivery"
            description="App notifications via the Gmail API (partnerships@bookboost.io). Auth emails route separately via Supabase Workspace SMTP."
            status={
              statusQuery.data?.email.appTransport.configured
                ? "connected"
                : "not_configured"
            }
            provider="email"
          />
          <IntegrationCard
            name="Crossbeam"
            description="Discover overlapping accounts and warm intros across partner ecosystems."
            status="coming_soon"
            provider="crossbeam"
          />
          <IntegrationCard
            name="Microsoft Teams"
            description="Mirror Slack-style notifications to a Teams channel."
            status="coming_soon"
            provider="teams"
          />
          <IntegrationCard
            name="Claude MCP"
            description="Expose Colab data to Anthropic's Claude via Model Context Protocol."
            status="coming_soon"
            provider="mcp"
          />
          <IntegrationCard
            name="Power BI"
            description="Embed per-partner Power BI dashboards on the partner detail page."
            status="coming_soon"
            provider="powerbi"
          />
        </div>
      )}
    </div>
  );
}
